import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(2),
    },
  },
}));

export default function ImageAvatars({ avatar, name }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Avatar alt= {name} src={avatar} />
    </div>
  );
}
